import { AfterViewInit, Component } from '@angular/core';
import { Agreement } from '../../models/api/core/agreements/agreement';
import { AgreementResponse } from '../../models/api/core/agreements/agreement-response';
import { BaseComponent } from '../base/base.component';
import { ButtonComponent } from '../core/buttons/button.component';
import { ActionRowComponent } from '../core/panels/action-row.component';
import { DialogComponent } from '../core/panels/dialog.component';
import { AgreementComponent } from '../layout/agreement.component';

@Component({
  selector: 'app-eula-verification',
  imports: [
    DialogComponent,
    ActionRowComponent,
    ButtonComponent,
    AgreementComponent,
  ],
  template: `
    <app-dialog
      #agreementDialog
      [visible]="this.agreementDialog"
      [closable]="false"
      label="User Agreement and License"
      classes="eula-title"
    >
      <ng-template #content>
        <app-agreement [agreement]="agreement" />
        <app-action-row class="tw-w-full">
          <app-button
            right1
            (click)="agreementDialog.visible = false"
            label="I Agree"
            (click)="onAcceptCondition()"
          />
        </app-action-row>
      </ng-template>
      <ng-template #footer>
        <div class="tw-font-bold tw-flex tw-w-full tw-justify-center">
          Please scroll down to read the User Agreement and License and to agree
          to the terms.
        </div>
      </ng-template>
    </app-dialog>
  `,
  styles: ``,
})
export class EulaVerificationComponent
  extends BaseComponent
  implements AfterViewInit
{
  agreementUid: string;
  agreementDialog = false;
  acceptAgreement: AgreementResponse;
  agreement: Agreement[] = [];

  ngAfterViewInit() {
    // TODO: We should only need to call this once per
    // user session. Removing refreshCache.
    this.api.agreement.pendingAgreement().then((pendingAgreements) => {
      if (pendingAgreements) {
        this.getAgreement();
      }
    });
  }

  getAgreement() {
    this.api.agreement.get().then((agreement) => {
      this.agreement = agreement;
      if (this.agreement.length > 0) {
        this.agreementUid = this.agreement[0].agreementUid;
        this.showDialog();
      }
    });
  }

  showDialog() {
    this.agreementDialog = true;
  }

  onAcceptCondition() {
    this.acceptAgreement = {
      agreementUid: this.agreementUid,
    };
    this.api.agreement.acceptAgreement(this.acceptAgreement);
  }
}
